import { API } from "../../Services";

export const partnerDetails = (id) =>{
    return (dispatch) =>{
        dispatch({
            type:"FETCH_PARTNER",
        })
         API.partnerDetails(id).then((res)=>{
            let data = JSON.parse(JSON.stringify(res)).data
            if(Array.isArray(data)){
                data = null
            }
            setTimeout(()=>{
                dispatch({
                    type:"RECEIVE_PARTNER",
                    payload:data,
                })
            },1000)
        }).catch((err)=>{
            dispatch({
                type:"ERROR_PARTNER",
            })
        })
    }
}